<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="OrderId"
      ref="list"
      unit="销售订单"
      :expand-all-row="true"
      :page="isShow"
      :show-checkbox="!is_listDialog && isShow"
      :show-query="showQuery"
      :get-data-func="api.docList"
      :showTrendTable="isShow"
      :query-params="params"
      urlHash="business/sales/saleorder"
      @showRow="toggleRow"
      :temp-params="tempParams"
      @getDataEnd="resetDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button type="primary" @click="onCustomTable" icon="el-icon-s-tools" style="margin: 30px 0 10px 10px"> 明细项 </el-button>
    <el-table ref="table" :row-key="row => row.Prop" :data="subList" @selection-change="handleSelectionChange" stripe border>
      <el-table-column type="selection" width="55"> </el-table-column>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else-if="isDateProperty(item.Prop)">
                {{ $commonJs.toDateString(row[item.Prop]) }}
              </span>
              <span v-else-if="isBooleanProperty(item.Prop)">
                <el-checkbox v-model="row[item.Prop]" :disabled="true"></el-checkbox>
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData="tableColumns" tableType="销售订单明细" />
    <!-- <el-table
      class="subItem-table"
      :data="subList"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" v-if="is_listDialog" width="55"> </el-table-column>
      <el-table-column
        align="left"
        prop="ProductNo"
        label="存货编码"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="ProductName"
        label="存货名称"
        min-width="140px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column align="left" label="规格型号">
        <template slot-scope="{ row }">
          <span>{{ row.ProductSpec }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="颜色" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="销售单位">
        <template slot-scope="{ row }">
          <span>{{ row.SaUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.SaQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="计量单位2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.UnitName2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="数量2">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="换算率">
        <template slot-scope="{ row }">
          <span>{{ row.Rate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税进价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.PurchasePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税售价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.SalePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最低售价" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.RetailPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.QuotedPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Price }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxLimit) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="预计交货状态日期" min-width="180px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.DeliveryDate) }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="行中止">
        <template slot-scope="{ row }">
          <el-checkbox v-model="row.LineAbort" :disabled="true"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column align="left" label="中止人">
        <template slot-scope="{ row }">
          <span>{{ row.LineAbortEmpName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="中止时间" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="已采购数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.PurchaseQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="已采购数量2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.PurchaseQuantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="累计生产数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ProductionQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="累计生产数量2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ProductionQuantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="执行数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExecutionQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="执行数量2">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExecutionQuantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="来源单据">
        <template slot-scope="{ row }">
          <span>{{ row.SourceTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="来源单号" min-width="180px">
        <template slot-scope="{ row }">
          <span>{{ row.DocNo }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="现存量">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="可用量">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import customTableDialog from '@/components/common/customTableDialog/customTableDialog'

import tableColumn from '@/data/business/sales/saleorder/list.json'
import tableParam from '@/data/business/sales/saleorder/query.json'
export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  props: {
    showTrendTable: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: true
    },
    showQuery: {
      type: Boolean,
      default: true
    },
    is_listDialog: {
      typeof: Boolean,
      default: false
    },
    isSelect: {
      typeof: Boolean,
      default: false
    }
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/sa/saOrder').default,
      FieldSettingApi: require('@/api/sy/fieldSetting').default,
      show: false,
      OrderNo: '',
      trendShow: true,
      subList: [],
      TradeUnitId: 0,
      FullName: '',
      subSelectList: [],
      tempParams: {
        SortName: 'OrderDate',
        SortOrder: 'DESC'
      },
      params: {
        RankName: ''
      },
      tableColumns: []
    }
  },
  mounted() {
    if (!this.$permission.canPrice('/business/sales/saleorder')) {
      const list = this.$refs.list
      const findIndex = list.tableList.findIndex(item => item.tableName == 'Amount')
      list.tableList.splice(findIndex, 1)
    }
    this.getTableColumns()
  },
  activated() {
    this.getRouterInfo()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/sales/saleorder')
    }
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false
      const priceProps = ['PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount']
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop)
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return [
        'SaQuantity',
        'Quantity2',
        'Amount',
        'TaxLimit',
        'TaxAmount',
        'DiscountAmount',
        'PurchaseQuantity',
        'PurchaseQuantity2',
        'ProductionQuantity',
        'ProductionQuantity2',
        'ExecutionQuantity',
        'ExecutionQuantity2',
        'StockQuantity',
        'ExistQuantity'
      ].includes(prop)
    },
    /** 格式化日期字段 */
    isDateProperty(prop) {
      return ['DeliveryDate', 'LineAbortDate'].includes(prop)
    },
    isBooleanProperty(prop) {
      return prop === 'LineAbort'
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: '销售订单明细' })
      this.tableColumns = []
      this.tableColumns = res.Data
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true
    },
    onSave() {
      this.getTableColumns()
      this.$message.success('保存成功')
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.OrderNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.OrderNo
        }
        if (this.$router.history.current.params.type === '明细') {
          console.log(this.$router.history.current.params, 'this.$router.history.current.params')
          if (this.$router.history.current.params.DocType === '销货单') {
            this.tempParams.SourceDocNo = {
              paramValueType: 'resetParamValue',
              isReset: true,
              value: this.$router.history.current.params.DocNo
            }
          } else {
            this.tempParams.OrderNo = {
              paramValueType: 'resetParamValue',
              isReset: true,
              value: this.$router.history.current.params.DocNo
            }
          }
        }

        this.tempParams.Ids = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        }

        this.tempParams.SourceType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceType
        }

        this.tempParams.SourceDocIds = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceDocIds
        }

        this.$refs.list.getData()
      }
    },
    // 选择报价明细
    handleSelectionChange(data) {
      this.subSelectList = data
    },
    toggleRow(data) {
      // if (!this.is_listDialog) return;-
      this.show = false
      console.log('data', data)
      this.OrderNo = data.OrderNo
      this.TradeUnitId = data.TradeUnitId
      this.FullName = data.FullName

      if (this.isSelect) {
        data.Products.forEach(item => {
          item.SaQuantity = item.SaQuantity - (item.SaDocOccupyQuantity ?? 0)
          item.Amount = item.SaQuantity * item.Price
          item.TaxAmount = item.SaQuantity * item.TaxPrice
        })

        let tList = data.Products.filter(item => {
          return item.SaQuantity > 0
        })
        console.log('tList', tList)
        this.subList = tList
      } else {
        this.subList = data.Products
      }

      // if (this.subList.length > 0) this.show = true;
    },
    delRange(ids) {
      this.api.delete({ ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success('删除成功')
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    finishRange(ids) {
      this.api.changeFinish({ ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success('操作成功')
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    resetDataFunc(resData) {
      console.log(resData, 'resData')
      resData.forEach(item => {
        if (item.DeliveryDate == '0001-01-01 00:00:00') {
          item.DeliveryDate = ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
